import { jsxs as r, jsx as l } from "react/jsx-runtime";
const t = (h) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M21.273 41.044a1.962 1.962 0 1 0-1.007-3.794 1.962 1.962 0 0 0 1.007 3.794ZM42.832 41.11a1.962 1.962 0 1 0 0-3.925 1.962 1.962 0 0 0 0 3.925Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.862 48.572h.8l-4.816 9.338h4.5l1.026-1.99h31.255l1.026 1.99h4.5l-4.814-9.338h4.299V6.062h-37.81a3.47 3.47 0 0 0-3.466 3.464v35.546c0 1.93 1.57 3.5 3.5 3.5Zm2.542 5.349.95-1.845h27.291l.951 1.845H17.404Zm1.982-3.845.776-1.504h23.676l.776 1.504H19.386Zm29.252-18.263H31.08l5.825-16.097h11.733v16.097ZM15.362 10.06h33.276v3.655H15.362V10.06Zm0 5.655h19.416l-5.825 16.097h-13.59V15.716Zm0 18.097h33.276v10.759H15.362v-10.76Z"
        }
      )
    ]
  }
);
export {
  t as Train
};
